module.exports = __webpack_public_path__ + "img/delphoi.24b1aea3.png";